var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2249 8.1747C24.7912 8.74096 24.7912 9.65904 24.2249 10.2253L12.6249 21.8253C12.0587 22.3916 11.1406 22.3916 10.5743 21.8253L4.7743 16.0253C4.20804 15.459 4.20804 14.541 4.7743 13.9747C5.34056 13.4084 6.25865 13.4084 6.82491 13.9747L11.5996 18.7494L22.1743 8.1747C22.7406 7.60843 23.6587 7.60843 24.2249 8.1747Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7bed57a82a02e8eb6190f149a5b4ce42.svg";
export { ForwardRef as ReactComponent };